/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OperationTypeEnum,
    OperationTypeEnumFromJSON,
    OperationTypeEnumFromJSONTyped,
    OperationTypeEnumToJSON,
} from './OperationTypeEnum';
import {
    PersonalAssetHistoryInputTypeEnum,
    PersonalAssetHistoryInputTypeEnumFromJSON,
    PersonalAssetHistoryInputTypeEnumFromJSONTyped,
    PersonalAssetHistoryInputTypeEnumToJSON,
} from './PersonalAssetHistoryInputTypeEnum';
import {
    PersonalAssetHistoryMetaDataDto,
    PersonalAssetHistoryMetaDataDtoFromJSON,
    PersonalAssetHistoryMetaDataDtoFromJSONTyped,
    PersonalAssetHistoryMetaDataDtoToJSON,
} from './PersonalAssetHistoryMetaDataDto';

/**
 * 
 * @export
 * @interface UpdatePersonalAssetHistoryDto
 */
export interface UpdatePersonalAssetHistoryDto {
    /**
     * 
     * @type {PersonalAssetHistoryMetaDataDto}
     * @memberof UpdatePersonalAssetHistoryDto
     */
    metaData?: PersonalAssetHistoryMetaDataDto;
    /**
     * 
     * @type {OperationTypeEnum}
     * @memberof UpdatePersonalAssetHistoryDto
     */
    operationType: OperationTypeEnum | null;
    /**
     * 
     * @type {PersonalAssetHistoryInputTypeEnum}
     * @memberof UpdatePersonalAssetHistoryDto
     */
    inputType: PersonalAssetHistoryInputTypeEnum | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePersonalAssetHistoryDto
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonalAssetHistoryDto
     */
    note?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UpdatePersonalAssetHistoryDto
     */
    date: Date;
}

export function UpdatePersonalAssetHistoryDtoFromJSON(json: any): UpdatePersonalAssetHistoryDto {
    return UpdatePersonalAssetHistoryDtoFromJSONTyped(json, false);
}

export function UpdatePersonalAssetHistoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePersonalAssetHistoryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'metaData': !exists(json, 'metaData') ? undefined : PersonalAssetHistoryMetaDataDtoFromJSON(json['metaData']),
        'operationType': OperationTypeEnumFromJSON(json['operationType']),
        'inputType': PersonalAssetHistoryInputTypeEnumFromJSON(json['inputType']),
        'value': json['value'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'date': (new Date(json['date'])),
    };
}

export function UpdatePersonalAssetHistoryDtoToJSON(value?: UpdatePersonalAssetHistoryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'metaData': PersonalAssetHistoryMetaDataDtoToJSON(value.metaData),
        'operationType': OperationTypeEnumToJSON(value.operationType),
        'inputType': PersonalAssetHistoryInputTypeEnumToJSON(value.inputType),
        'value': value.value,
        'note': value.note,
        'date': (value.date.toISOString()),
    };
}

